import { connect } from "react-redux";
import InventoryChecklist from "./inventoryChecklist";
import { bindActionCreators } from "redux";
import {
  getInventory,
  postGateInventory,
} from "services/redux/installation/inventoryCheckList/action";
import { getMateriaById,getBrandById } from "services/redux/sales/postSales/corporate/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import {
  getGateDetail
} from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
  inventoryData: state.inventoryReducer.inventoryData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.coporatePostLeadReducer.getBrand,
  gateInfo: state.handOverReducer.gateInfo,
  gateDetail: state.siteInspectionReducer.gateDetail,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInventory,
      getMateriaById,
      postGateInventory,
      getGateInfo,
      getBrandById,
      getGateDetail,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InventoryChecklist);
